export default __webpack_public_path__ + "static/media/PizzaMoneyAd.46f333da.jpg";